import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

import { AuthService, AppInfoService } from '../../services';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';
import { UtilitiesService } from '../../services/utilities.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent {
  email = '';
  email2 = '';
  password='';
  passwordMode: string;
  passwordButton: any;
  errorMsg: boolean = false;
  errorMsg2: boolean = false;
  emailRequestErrorMsg: boolean = false;
  emailRequestErrorMsg2: boolean = false;
  requestingEmail: boolean = false;
  emailSenntMessage: boolean = false;
  udta:any;

  constructor(
    private authService: AuthService,
    public appInfo: AppInfoService,
    private router: Router,
    private utilitiesService: UtilitiesService
  ) {
    this.passwordMode='password';
    this.passwordButton = {
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAANlBMVEX///8AAAABpSIBpSIBpSIBpSIBpSIBpSIBpSIBpSIBpSIBpSIBpSIBpSIBpSIBpSIBpSL///9MgC9VAAAAEHRSTlMAAER3mTNm7swRu1WI3SKqvxvUXQAAAAFiS0dEAIgFHUgAAAAHdElNRQflAhcXJy9VLiYeAAAAgklEQVQY062QQRLEIAgEg6iIBOT/rw1otva6h+0T1cjUlNf1TyApWCu2PR7VyTejvIqnD+EuDcnvo6b3WJKrcXVMhWGYJe8AqpdQviL9ZOXjEWoQQ9uGcneHaj458gIEI+WMF1fhW0cHJLLTq6hrRVzk0z5VoechLfm2T8ze4cd/eAA9dQV1uhN5twAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wMi0yM1QyMzozOTo0NyswMDowMOpK9SoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMDItMjNUMjM6Mzk6NDcrMDA6MDCbF02WAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAABJRU5ErkJggg==",
      type: "default",
      onClick: () => {
        this.passwordMode = this.passwordMode === "text" ? "password" : "text";
      }
  };

  }

  async signIn(args) {
    try {
      if (!args.validationGroup.validate().isValid) {
        return;
      }
      const cid = await this.authService.signIn(this.email, this.password);
      console.log("cid = ", cid)
      this.udta = this.utilitiesService.getUserData();
      if (cid) {
        if(this.udta.level != 5) {
          this.router.navigate([`/dash/home`]);
        } else {
          this.authService.logOut();
          this.errorMsg = false;
          this.errorMsg2 = true;
        }
      } else {
        this.errorMsg = true;
        this.errorMsg2 = false;
        //log in error
      }
      args.validationGroup.reset();
    } catch (err) {
      console.log(err);
    }
  }
  forgotPswd(bol) {
    this.requestingEmail = bol;
  }

  requestEmail() {
    // console.log(this.email2);
    this.authService.sendUserEmailInstructions(this.email2).then(data => {
      // console.log('enviado');
    });
    this.emailSenntMessage = true;
  }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxValidationGroupModule,
  ],
  declarations: [LoginFormComponent],
  exports: [LoginFormComponent]
})
export class LoginFormModule { }
